import * as React from 'react';

import { useSelector } from 'react-redux';
import { Checkbox, CheckboxVisibility, ConstrainMode, IColumn, MessageBar, MessageBarType, SelectionMode, ShimmeredDetailsList, Toggle } from '@fluentui/react';
import { RootState } from '../../redux/types';
import { useParams } from 'react-router-dom';
import { ServiceOffering } from '../../api/services.types';

export const MarketServices = () => {
  const services = useSelector((state: RootState) => state.serviceOffering.services);
  const { code } = useParams<any>();
  const markets = useSelector((state: RootState) => state.markets.allMarkets);
  const market = markets.data?.find((m) => m.code === code);

  const columns: IColumn[] = [
    {
      key: 'code',
      name: 'Service Code',
      fieldName: 'code',
      minWidth: 120,
      maxWidth: 120,
    },
    {
      key: 'name',
      name: 'Name',
      fieldName: 'name',
      minWidth: 120,
      maxWidth: 240,
    },
    {
      key: 'age',
      name: 'Age',
      minWidth: 90,
      maxWidth: 90,
      onRender: (item: ServiceOffering) => <span>{`${item.ageMinimum} - ${item.ageMaximum}`}</span>,
    },
    {
      key: 'insurance',
      name: 'Insurance',
      fieldName: 'insurance',
      minWidth: 80,
      maxWidth: 80,
      onRender: (item: ServiceOffering) => <Toggle disabled={true} checked={item.allowInsurance} />,
    },
    {
      key: 'public',
      name: 'Public',
      fieldName: 'public',
      minWidth: 60,
      maxWidth: 60,
      onRender: (item: ServiceOffering) => <Toggle disabled={true} checked={item.public} />,
    },
    {
      key: 'visibleToPatient',
      name: 'Patient can book',
      fieldName: 'visibleToPatient',
      minWidth: 160,
      maxWidth: 160,
      onRender: (item: ServiceOffering) => {
        const som = market?.serviceOfferingMarkets.find((s) => s.serviceCode === item.code);
        return <Checkbox disabled={!som} checked={som?.visibleToPatient} />;
      },
    },
    {
      key: 'visibleToFollowUpVisit',
      name: 'Provider can book',
      fieldName: 'visibleToFollowUpVisit',
      minWidth: 160,
      maxWidth: 160,
      onRender: (item: ServiceOffering) => {
        const som = market?.serviceOfferingMarkets.find((s) => s.serviceCode === item.code);
        return <Checkbox disabled={!som} checked={som?.visibleToFollowUpVisit} />;
      },
    },
    {
      key: 'enabled',
      name: 'Enabled',
      fieldName: 'enabled',
      minWidth: 60,
      maxWidth: 60,
      onRender: (item: ServiceOffering) => {
        const som = market?.serviceOfferingMarkets.find((s) => s.serviceCode === item.code);
        return <Checkbox checked={!!som} />;
      },
    },
  ];

  return (
    <>
      <MessageBar messageBarType={MessageBarType.warning}>This is read-only at this time - updates have not been implemented yet.</MessageBar>
      <ShimmeredDetailsList
        enableShimmer={services.isFetching}
        shimmerLines={8}
        compact={true}
        selectionMode={SelectionMode.none}
        constrainMode={ConstrainMode.horizontalConstrained}
        checkboxVisibility={CheckboxVisibility.hidden}
        items={services.data || ([] as any)}
        setKey="set"
        columns={columns}
      />
    </>
  );
};
